import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "junk-drawer",
  "use": "junk-drawer-usage",
  "viewBox": "0 0 46 16",
  "content": "<symbol viewBox=\"0 0 46 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"junk-drawer\"><path d=\"M0 2L28 2 28 0 0 0zM0 9L28 9 28 7 0 7zM0 16L28 16 28 14 0 14zM36 7L41 12 46 7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/junk-drawer.svg
// module id = 1735
// module chunks = 0